module.exports = __webpack_public_path__ + "static/media/B_F03.c4ab3627.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BLUE/B_F03.png
// module id = 65
// module chunks = 0